import List from './PaymentList'

const exportObj = {
    List
}

export default exportObj